import type { ReportNotice } from "@clubcore/api";
import { useT } from "../../i18n/I18nProvider";
import { Icon } from "../../ui/Icon";

/**
 * What the data behind a report covers, in plain words, from the server (for example: the spending history from Jonas has not been
 * imported yet, so the report covers activity in ClubCore only). Shown above a result, on the dashboard and in the builder, so an empty
 * or short report is never left to speak for itself.
 */
export function DataNotices({ notices }: { notices: readonly ReportNotice[] | undefined }) {
  const t = useT();
  if (!notices || notices.length === 0) return null;
  return (
    <div className="cc-r-datanotices" role="note" aria-label={t("reports.notices.label")}>
      {notices.map((notice) => (
        <p key={notice.code + notice.message} className={`cc-r-notice cc-r-datanotice cc-r-datanotice--${notice.code}`}>
          <Icon name="alert" size={18} aria-hidden="true" />
          <span>{notice.message}</span>
        </p>
      ))}
    </div>
  );
}

/** True when a notice says the data a report needs has not been imported (the result is empty or partial for that reason). */
export function missingHistory(notices: readonly ReportNotice[] | undefined): ReportNotice | undefined {
  return notices?.find((notice) => notice.code === "history_not_imported" || notice.code === "history_not_applied");
}
